import Check from '@mui/icons-material/Check';
import Close from '@mui/icons-material/Close';
import { Box } from '@mui/material';

/** Círculo de 64 px com ✓ (sucesso) ou ✕ (falha) dos desfechos da jornada 2026 (renovação e troca de cartão). */
export default function JourneyStatusIcon({ kind }: { kind: 'success' | 'error' }) {
  return (
    <Box
      sx={{
        alignItems: 'center',
        bgcolor: kind === 'success' ? 'success.main' : 'error.light',
        borderRadius: '100px',
        color: 'common.white',
        display: 'flex',
        height: 64,
        justifyContent: 'center',
        width: 64
      }}
    >
      {kind === 'success' ? <Check aria-hidden sx={{ fontSize: 32 }} /> : <Close aria-hidden sx={{ fontSize: 32 }} />}
    </Box>
  );
}
